import React, {Component} from 'react'
import YesNoRadio from './YesNoRadio'
import Collapse from '@material-ui/core/Collapse';
import shallowEqual from 'shallowequal'

export class OptionalInput extends Component {

  shouldComponentUpdate = nextPropsParam => {
    const {children, ...props} = this.props
    const {children: nextChildren, ...nextProps} = nextPropsParam

    if (!shallowEqual(props, nextProps))
      return true

    const child = Array.isArray(children) ? children[0] : children
    const nextChild = Array.isArray(nextChildren) ? nextChildren[0] : nextChildren

    return (nextChild.type !== child.type || !shallowEqual(nextChild.props, child.props))
  }


  handleYesNoChange = event => {
    this.props.onChange({target: {value: event.target.value}})
  }

  render = () => {
    const {value, disabled, children} = this.props

    return (
      <div>
        <YesNoRadio value={value} onChange={this.handleYesNoChange} disabled={disabled}/>
        <Collapse in={!!value}>
          {children}
        </Collapse>
      </div>
    )
  }
}

export default OptionalInput